import { PicklistsTab } from '../components/PicklistsTab';
import { usePageTitle } from '@/hooks/usePageTitle';

/**
 * PW-12 — the page is a thin wrapper on purpose.
 *
 * Its `PageHeader` moved into `PicklistsTab` because the header's Refresh button has to re-issue the
 * CURRENT page, size, sort and filter, and all four live in the tab. A header up here would need those
 * threaded back out, and the failure mode of getting that wrong is silent: the table resets to page 1
 * while the address bar still says page 7.
 */
export function PicklistsPage() {
  usePageTitle('Picklists');
  return <PicklistsTab />;
}
